import React from 'react';
import { useSelector } from 'react-redux';
import {
  frequencySelector,
  leadDataSelector,
} from '../../ecg/selectors/signal.selectors';
import { LeadsContainer } from './LeadsContainer';

interface Props {
  colorLeads?: boolean;
}

export const DefaultLeads: React.FC<Props> = ({ colorLeads = false }) => {
  const frequency = useSelector(frequencySelector);
  const leads = useSelector(leadDataSelector);

  return (
    <LeadsContainer
      frequency={frequency}
      leadsData={leads}
      colorLeads={colorLeads}
    />
  );
};
